import { FormValidation } from '@/suppliers/form-validation';
import { ProductUpload } from '@/suppliers/product-upload';
import { DocumentUpload } from '@/suppliers/document-upload';


$(document).ready(() => {
    FormValidation.init();
    ProductUpload.init();
    DocumentUpload.init();
});
